
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/landing/original/[[...pathParams]]",
      function () {
        return require("private-next-pages/landing/original/[[...pathParams]].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/landing/original/[[...pathParams]]"])
      });
    }
  